export interface ColumnSettings {
  order: string[]
  visibility: Record<string, boolean>
}

/**
 * Derives a stable localStorage key from the current route pathname.
 * Strips numeric segments (IDs) so that e.g. /consumers/123/details
 * and /consumers/456/details share the same key: "columnSettings_consumers_details"
 */
export function getColumnStorageKey(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean)
  const nonNumeric = segments.filter(s => isNaN(Number(s)))
  return `columnSettings_${nonNumeric.join('_') || 'default'}`
}

export function getColumnSettings(key: string): ColumnSettings | null {
  try {
    const saved = localStorage.getItem(key)
    return saved ? JSON.parse(saved) : null
  } catch {
    return null
  }
}

export function saveColumnSettings(key: string, settings: ColumnSettings): void {
  try {
    localStorage.setItem(key, JSON.stringify(settings))
  } catch {
    // localStorage full or unavailable
  }
}
